import { videosLoaded } from '../slices/videos/videosSlice';
import { store } from '../store/store';
import axiosInstance from './axiosCreator';
import { WatchState } from '../types/Video';

// Get All Videos
export const getGroupedVideos = async () => {
  try {
    const response = await axiosInstance.get('/videos/by-level-one');
    return response.data;
  } catch (error) {
    console.error('Error fetching videos:', error);
    throw error;
  }
};

// Increment Video View Count
export const incrementVideoView = async (videoId: string) => {
  try {
    const response = await axiosInstance.post(`/videos/${videoId}/view`);
    return response.data;
  } catch (error) {
    console.error('Error incrementing video view:', error);
    throw error;
  }
};

export const fetchStudySessionVideos = async (studySessionId: string) => {
  try {
    const response = await axiosInstance.get(
      `/study/session/${studySessionId}/videos`
    );
    store.dispatch(videosLoaded(response.data.videos));
    return response.data.videos;
  } catch (error) {
    console.error('Error fetching videos:', error);
    throw error;
  }
};

// Update Video Scheduling
export const updateVideoScheduling = async (
  videoId: string,
  watchState: WatchState
) => {
  try {
    const response = await axiosInstance.post(`/videos/${videoId}/schedule`, {
      watchState,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating video scheduling:', error);
    throw error;
  }
};
